import { chainNameToNetworkName } from "@src/shared/utils/display"
import {
  chainIcons,
  INTERNAL_NETWORK_NAME,
  internalNetworkIcon,
} from "../../../constants/blockchains"
import type { ContactNetwork } from "./contactNetwork"

type ContactNetworkDisplayInfo = {
  icon: { dark: string; light: string }
  label: string
  capitalize: boolean
  isInternal?: boolean
}

/**
 * Display info for a contact's network (contact lists, recipient selectors).
 */
export function getContactNetworkDisplayInfo(
  network: ContactNetwork
): ContactNetworkDisplayInfo {
  if (network === "near_intents") {
    return {
      icon: internalNetworkIcon,
      label: `${INTERNAL_NETWORK_NAME} user`,
      capitalize: false,
    }
  }
  return {
    icon: chainIcons[network],
    label: chainNameToNetworkName(network),
    capitalize: true,
  }
}

/**
 * Display info for a network in transfer/review contexts.
 */
export function getNetworkDisplayInfo(
  network: ContactNetwork
): ContactNetworkDisplayInfo {
  if (network === "near_intents") {
    return {
      icon: internalNetworkIcon,
      label: INTERNAL_NETWORK_NAME,
      capitalize: false,
      isInternal: true,
    }
  }
  return {
    icon: chainIcons[network],
    label: chainNameToNetworkName(network),
    capitalize: true,
  }
}
